import { useMemo } from 'react';
import { useRoutesContext } from '../';

export const useStationServicePrices = (stationCode?: string, serviceCode?: string) => {
  const { routesStationServicePrices } = useRoutesContext();

  return useMemo(() => {
    if (!stationCode || !serviceCode || !routesStationServicePrices) {
      return;
    }

    const stationServices = routesStationServicePrices[stationCode] || [];
    return stationServices.find(({ service }) => service.code.toString() === serviceCode.toString());
  }, [
    stationCode,
    serviceCode,
    routesStationServicePrices
  ]);
};
